import { Component, OnInit } from "@angular/core";
import { MemberappBaseComponent } from "../memberapp-base/memberapp-base.component";
import { FormGroup, FormArray } from "@angular/forms";
import {
	SectionDetails,
	SectionInfo
} from "../../../shared/models/section-details";
import { NotificationStatus } from "../../../shared/enums/data.enums";
declare var moment;

@Component({
	selector: "app-sections",
	templateUrl: "./sections.component.html",
	styleUrls: ["./sections.component.scss"]
})
export class SectionsComponent extends MemberappBaseComponent {
	sectionForm: FormGroup;
	// ui_Sections = this.memberAppDataService.memberAppData.AccountProducts.filter(
	//   a => a.productsubtype == "SECT"
	// );
	sectionDetails: SectionDetails;
	freeSectionsPresent: boolean = false;
	showFreeSectionMarketing: boolean = true;
	isSectionApp: boolean = false;
	SECTIONAPPDETAILS_KEY: string = "SECTIONAPPDETAILS";

	get sectionFormArray(): FormArray {
		return this.sectionForm.get("sections") as FormArray;
	}

	ngOnInit() {
		//this.loggerService.logInfo(this.memberAppDataService.memberAppData);
		this.initSectionApp();

		//reset
		this.resetForm();

		//subscriptions
	}

	initSectionApp() {
		this.isSectionApp = this.dataService.IsSectionApplication;
		if (this.isSectionApp) {

			let md = this.memberAppDataService.memberAppData;

			if (md) {
				//If Past Member, they are not eligbile for Section Membership until they renew their Membership
				let pastMember = this.sectionsService.checkIfPastAcepMember_SectionApp();
				if (pastMember) {
					md.notifyInfo.status = NotificationStatus.SectionApplication_Ineligible;
					this.memberAppDataService.navigateToRoute('notifysectionapp');
					return false;
				}
			}

			//load saved selections from LS if coming back from Shopping Cart
			if (document.referrer && document.referrer.toLowerCase().indexOf('shoppingcart') > -1) {
				let savedSections = this.dataService.GetFromLocalStorage(this.SECTIONAPPDETAILS_KEY);

				if (savedSections) {
					md.sectionDetails.sections.forEach(a => a.selected = !a.enabled || savedSections.split(',').indexOf(a.productnumber) > -1)
				}
			}
		}
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
		this.memberAppDomService.initSectionStyles();

		this.showFreeSectionMarketing = !this.memberAppDataService.memberAppData.profile.IsRegYR123;
	}

	resetForm() {
		this.sectionDetails = this.memberAppDataService.memberAppData.sectionDetails;
		this.freeSectionsPresent =
			this.sectionDetails.sections.filter(a => a.isFree).length > 0;
		//this.giveSomeTestData();

		this.sectionForm = this.fb.group({
			sections: this.fb.array(
				this.sectionDetails.sections.map(a => this.createItem(a))
			)
		});
	}

	GetSelectedSections() {
		let selectedSections = this.SelectedSections
			.map(a => `${a.get("name").value}`)
			.join(" | ");
		if (!selectedSections) {
			selectedSections = "None";
		}

		return selectedSections;
	}

	get SelectedSections() {
		return this.sectionFormArray.controls
			.filter(a => a.get("selected").value && a.get("enabled").value);
	}



	createItem(ad: SectionInfo): FormGroup {
		return this.fb.group({
			name: ad.name.replace(" Section", ""),
			id: ad.id,
			url: ad.url,
			code: ad.code,
			productnumber: ad.productnumber,
			description: ad.description,
			img: ad.img,
			selected: ad.selected,
			enabled: ad.enabled,
			isFree: ad.isFree //No Price ..eg: YPS for Candidates
		});
	}

	prepareDataModel(): SectionDetails {
		let p: SectionDetails = Object.assign(
			{},
			this.sectionDetails,
			this.sectionForm.value
		) as SectionDetails;
		return p;
	}

	save() {
		super.onSave(this.sectionForm);

		this.sectionDetails = this.prepareDataModel();

		this.onSaveComplete();
	}

	onSaveComplete() {
		this.memberAppDataService.memberAppData.sectionDetails = this.sectionDetails;
		if (this.isSectionApp) {
			//save selected sections in local storage so they can be retrieved when coming back from Shopping Cart
			this.dataService.SaveInLocalStorage(
				this.SECTIONAPPDETAILS_KEY, this.SelectedSections
					.map(a => `${a.get("productnumber").value}`)
					.join(",")
			);
			this.sectionsService.CalculateSectionOrder(this.memberAppDataService.memberAppData);
		}
		else {
			this.globalDomOpsService.notify("Sections Information Updated");
			this.memberAppDataService.navigateToRoute("checkout");
		}
	}
}
